import { useEffect } from 'react';
import { useNavigate } from 'react-router';
import { useMissionsStore } from 'src/store/missions/missions.store';

export const useMissionsList = () => {
  const navigate = useNavigate();
  const { getMissionsList, isLoadingMissionsList, missionsList } = useMissionsStore();

  useEffect(() => {
    getMissionsList();
  }, []);

  const getReward = (mission: any) => {
    switch (mission.missionType) {
      case "scan-count":
        return mission.scanCountData?.reward ?? 0;
      case "instant":
        return mission.instantData?.reward ?? 0;
      case "quiz":
        return (mission.quizData?.pointsPerQuestion ?? 0) * (mission.quizData?.questions?.length ?? 0);
      case "check-in":
        return mission.checkInData?.stagesReward?.reduce((acc: number, num: number) => acc + num, 0) ?? 0;
      default:
        return 0;
    }
  };

  const TABLEHEADER = [
    { id: "missionType", type: "mission-type", label: "Tipo" },
    { id: "name", label: "Nome" },
    { id: "reward", label: "Recompensa (em pontos)" },
    { id: "status", label: "Status", type: "label" },
  ];

const validMissionTypes = ["scan-count", "quiz", "check-in", "instant"];

const formattedMissionsList = Array.isArray(missionsList) && missionsList.length > 0
  ? missionsList
      .filter((mission) => validMissionTypes.includes(mission.missionType))
      .map((mission) => ({
        ...mission,
        reward: getReward(mission),
      }))
  : [];



  return {
    navigate,
    isLoadingMissionsList,
    missionsList: formattedMissionsList,
    TABLEHEADER,
  };
};

